<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group
            :description="$t('functions.form.fields.nome.description')"
            :label="$t('functions.form.fields.nome.label')"
            label-for="input-name"
        >
          <b-form-input id="input-name" v-model="functions.name"/>
        </b-form-group>
        <b-form-group
            :description="$t('functions.form.fields.url.description')"
            :label="$t('functions.form.fields.url.label')"
            label-for="input-function_url"
        >
          <b-form-input id="input-function_url" v-model="functions.function_url"/>
        </b-form-group>
        <b-form-group
            :description="$t('functions.form.fields.url_autenticacao.description')"
            :label="$t('functions.form.fields.url_autenticacao.label')"
            label-for="input-auth_url"
        >
          <b-form-input id="input-auth_url" v-model="functions.auth_url"/>
        </b-form-group>
        <b-form-group
            :description="$t('functions.form.fields.classe_autenticacao.description')"
            :label="$t('functions.form.fields.classe_autenticacao.label')"
            label-for="input-auth_class"
        >
          <b-form-input id="input-auth_class" v-model="functions.auth_class"/>
        </b-form-group>
        <b-form-group
            :description="$t('functions.form.fields.credencial.description')" 
            :label="$t('functions.form.fields.credencial.label')"
            label-for="input-credential_id"
        >
          <b-overlay :show="store_credentials_loading">
            <SelectComponent
                  id="input-credential_id"
                  :model="functions.credential"
                  :options="store_credentials | idNameToValueLabel"
                  @search="evt => {autocomplete('credential', evt)}"
                  @input="evt => setFunction('credential', evt)"
              />
          </b-overlay>
        </b-form-group>
        <b-form-group
            :description="$t('functions.form.fields.classe_montagem.description')"
            :label="$t('functions.form.fields.classe_montagem.label')"
            label-for="input-assembling_class"
        >
          <b-form-input id="input-assembling_class" v-model="functions.assembling_class"/>
        </b-form-group>
        <b-form-group
            :label="$t('functions.form.fields.credencial_incluida.label')"
            label-for="input-has_credential_included"
            :description="$t('functions.form.fields.credencial_incluida.description')"
        >
          <b-form-checkbox id="input-has_credential_included" v-model="functions.has_credential_included" size="lg"
                           switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('functions.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient"
import FunctionsRepository from '@/repositories/FunctionRepository'
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex"

export default {
  name: "Form",
  components: { LayoutGradient, SelectComponent },
  computed: {
    ...mapGetters({
      functions: 'functions/current',
      isLoading: 'functions/isLoading',
      store_credentials: 'credential/all',
      store_credentials_loading: 'credential/isLoading',
    }),
    pageTitle() {
      if (this.functions_id) return this.$t('functions.form.titulo_pagina.editar')
      return this.$t('functions.form.titulo_pagina.criar')
    },
    credentials() {
      if (this.store_credentials && Array.isArray(this.store_credentials)) {
        return this.store_credentials.map((ent) => {
          return {
            text: ent.name,
            value: ent.id
          }
        })
      }
      return [];
    }
  },
  data() {
    return {
      functions_id: null
    }
  },
  methods: {
    ...mapActions([
      'functions/listOne',
      'credential/search'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      this.functions.credential_id = (this.functions.credential != null) ? this.functions.credential.value : this.functions.credential ;

      FunctionsRepository.post(this.functions).then(() => {
        this.$snotify.success(this.$t('functions.form.create.success'))
        this.$router.push({name: 'functions'})
      }).catch(error => {
        this.$snotify.error(this.$t('functions.form.create.error'))
        if (error.response.status === 422) {
          FunctionsRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      this.functions.credential_id = (this.functions.credential != null) ? this.functions.credential.value : this.functions.credential ;
      
      FunctionsRepository.put(this.functions_id, this.functions).then(() => {
        this.$snotify.success(this.$t('functions.form.update.success'))
        this.$router.push({name: 'functions'})
      }).catch(error => {
        this.$snotify.error(this.$t('functions.form.update.error'))
        if (error.response.status === 422) {
          FunctionsRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    async autocomplete(entityString, string) {
      if (string && string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this[`${entityString}/search`]({filters: [array]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    },
    setFunction(key, value) {
      this.$store.commit('functions/setCurrent', {...this.functions, [key]: value})
    },
  },
  async mounted() {
    this.$store.commit('functions/setCurrent', {has_credential_included: false})
    await this['credential/search']()
    if (this.$route.params.id) {
      this.functions_id = this.$route.params.id
      await this['functions/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
